import { createDynamicSlice } from ".";
import { getListOfExpenseListThunk } from "../thunks/listOfExpensesThunk";

export const listOfExpensesSlice = createDynamicSlice({
  name: "listOfExpenses",
  thunk: getListOfExpenseListThunk,
  listMode: true,
  resetActionName: "resetListOfExpenses",
});

export const listOfExpensesReducer = listOfExpensesSlice.reducer;
export const { resetListOfExpenses } = listOfExpensesSlice.actions;
